/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_OfflineInputs */

const en_us2_invite_offline = /** @type {(inputs: Invite_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to see your invite.`)
};

const pt_br2_invite_offline = /** @type {(inputs: Invite_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver seu convite.`)
};

const pt_pt2_invite_offline = /** @type {(inputs: Invite_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver seu convite.`)
};

/** @type {(inputs: Invite_OfflineInputs) => LocalizedString} */
const es_419_invite_offline = en_us2_invite_offline;

/** @type {(inputs: Invite_OfflineInputs) => LocalizedString} */
const fr_fr2_invite_offline = en_us2_invite_offline;

/** @type {(inputs: Invite_OfflineInputs) => LocalizedString} */
const de_de2_invite_offline = en_us2_invite_offline;

/** @type {(inputs: Invite_OfflineInputs) => LocalizedString} */
const it_it2_invite_offline = en_us2_invite_offline;

/**
* | output |
* | --- |
* | "Connect to the internet to see your invite." |
*
* @param {Invite_OfflineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_offline = /** @type {((inputs?: Invite_OfflineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_OfflineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_offline(inputs)
	if (locale === "es-419") return es_419_invite_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_offline(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_offline(inputs)
	if (locale === "de-DE") return de_de2_invite_offline(inputs)
	if (locale === "it-IT") return it_it2_invite_offline(inputs)
	return en_us2_invite_offline(inputs)
});
export { invite_offline as "invite.offline" }